
export const tinTucRules = {
  name: "required|min:5|max:256", // Tiêu đề chỉ có 256 ký tự (CHUẨN SEO)
  describe: "required|min:5|max:500", // Mô tả ngắn chỉ có 100 ký tự (CHUẨN SEO)
  fileImage: "hasFileId",
  nameAuthor:"required|min:3|max:100",
};

export const tinTucValidator = {
  rules: tinTucRules,
};
